import { useQuery, UseQueryOptions } from 'react-query'
import { AxiosError } from 'axios'

import { getProjectsStatus } from 'api/clients'
import { QueryKey } from 'constants/endpoint'
import { useClient } from './useClient'
import { GETProjectsStatusResponse } from 'api/types/ProjectsStatusResponse'

type TData = GETProjectsStatusResponse
type TError = AxiosError<unknown>

export const useGetProjectsStatus = (
  options?: UseQueryOptions<TData, TError>
) => {
  const client = useClient()

  return useQuery<TData, TError>(
    [QueryKey.PROJECTS_STATUS],
    async () => {
      return getProjectsStatus(client)
    },
    {
      ...options
    }
  )
}
